"use strict";
/**
 * Builds the public social/og:image URL.
 *
 * The media service composes the image on demand (deterministic color by id,
 * white card with the company logo); this helper only builds the URL. The
 * design version is part of the query so a design change gets a fresh URL
 * (the response is served `immutable`).
 * Without a company image — or without a deterministic id — it returns the
 * static homepage meta image, preserving the `uk` variant.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const social_image_version_1 = require("@shared/social-image-version");
const getHomepageMetaImage = (locale) => locale === 'uk'
    ? `${process.env.PUBLIC_URL}/media/images/meta-homepage-uk.jpg`
    : `${process.env.PUBLIC_URL}/media/images/meta-homepage.jpg`;
const getSocialImageUrl = ({ offerId, companyId, companyImage, jobAreaId, locale }) => {
    if (!companyImage) {
        return getHomepageMetaImage(locale);
    }
    const targetPath = offerId ? `offer/${offerId}` : companyId ? `company/${companyId}` : null;
    if (!targetPath) {
        return getHomepageMetaImage(locale);
    }
    const params = new URLSearchParams();
    params.set('company', companyImage);
    if (jobAreaId) {
        params.set('jobAreaId', String(jobAreaId));
    }
    params.set('v', String(social_image_version_1.SOCIAL_DESIGN_VERSION));
    return `${process.env.PUBLIC_URL}/api/0/media/social/${targetPath}.jpg?${params.toString()}`;
};
exports.default = getSocialImageUrl;
